import React, { useState, useEffect } from 'react'

import HoverTooltip from '../../../../../../components/HoverTooltip'
import MoneyInput from '../../../../../../components/form/MoneyInput'
import CurrencySelector from '../../../../../../components/currency/CurrencySelector'

import PerformanceDocumentTable from './PerformanceDocumentTable/PerformanceDocumentTable'

import Section from '../../../../../../components/Section'
import { Contract, ContractPerformance } from '../../../types'

import { CurrencyList } from '../../types'

import { PerformanceDocumentsError } from '../types'

type Props = {
    theme: string
    perfAction: boolean
    contractGuid: string | undefined
    performance: ContractPerformance
    performanceGuid: string | undefined
    role: string
    onPerformanceDocuments: (have_perf_documents: boolean) => void
    errors?: PerformanceDocumentsError
    onAnyEdit: () => void
}

const formatNumber = (num: number | string | null | undefined): string => {
    if (num === null || num === undefined) return '-' // Обрабатываем пустые значения

    const parsedNum = typeof num === 'number' ? num : parseFloat(num)

    if (isNaN(parsedNum)) {
        return '-' // Обрабатываем некорректные значения
    }

    return parsedNum
        .toFixed(2) // Два знака после запятой
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') // Разделяем тысячные пробелами
        .replace('.', ',') // Заменяем точку на запятую
}

const PerformanceDocuments: React.FC<Props> = (props) => {
    return (
        <Section title="Документы">
            <div className="flex flex-col w-full gap-x-5 space-y-3">
                <div className="flex flex-col w-full gap-x-5 ">
                    <div className={`flex flex-col min-w-[200px]`}>
                        <PerformanceDocumentTable
                            theme={props.theme}
                            perfAction={props.perfAction}
                            performanceGuid={props.performanceGuid}
                            role={props.role}
                            onPerformanceDocuments={
                                props.onPerformanceDocuments
                            }
                            errors={props.errors}
                            onAnyEdit={props.onAnyEdit}
                        />
                    </div>
                </div>
            </div>
        </Section>
    )
}

export default PerformanceDocuments
